module.exports = __webpack_public_path__ + "media/images/emblems/Valsot-0eba7d6f14c47900d5cce8d772e40bb5.gif";